import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';

import { AuthService } from '../services/auth.service';

const buildLoginRedirect = (router: Router, returnUrl: string): UrlTree =>
  router.createUrlTree(['/login'], {
    queryParams: {
      returnUrl
    }
  });

const resolveAuthState = (returnUrl: string): boolean | UrlTree | Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  if (!authService.hasStoredToken()) {
    return buildLoginRedirect(router, returnUrl);
  }

  return authService.restoreSession().pipe(
    map(user => (user ? true : buildLoginRedirect(router, returnUrl))),
    catchError(() => of(buildLoginRedirect(router, returnUrl)))
  );
};

export const authGuard: CanActivateFn = (_route, state) => resolveAuthState(state.url);

export const authChildGuard: CanActivateChildFn = (_route, state) => resolveAuthState(state.url);
